export function createCache(store) {
  return {
    get: function get(key, supplier) {
      var value = store.get(key);
      if (value != null) {
        return value;
      }
      var v = supplier();
      store.set(key, v);
      return v;
    }
  };
}